import React, { Fragment } from 'react'
import styled from 'styled-components'
import css from '@styled-system/css'

import { useUserContext } from 'context'

import { Flex, ResponsiveSVG } from 'ui/acro'
import { ChevronRightIcon } from 'components_v2/Icons'
import { YogaMat, AloMovesLogo } from 'images/latest'

import { topCategory } from '../../common/data/topCategory'

import MobileMenuLink from '../common/MobileMenuLink'
import { HalfDivider } from '../common/Dividers'
import AppStoreComponent from '../../common/AppStoreComponent'
import CommonLink from 'components_v2/CommonLink'
import { NEW_NAVBAR_ITEMS, EVENTS_MENU_DISABLED } from 'components_v2/common'

export const MobileMenuPrimaryPage = styled(Flex)`
  ${css({
    flexDirection: 'column',
    pb: 'calc(15px + env(safe-area-inset-bottom))'
  })}
`

const MobileMenuLinkWrapper = styled(MobileMenuLink)(() =>
  css({
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    justifyContent: 'space-between',
    height: '4.5rem',
    borderTop: '1px solid #CCC',
    '&:last-of-type': {
      borderBottom: '1px solid #CCC',
      marginBottom: '15px'
    }
  })
)

const MobileMenuPrimary = (props) => {
  const { user } = useUserContext()

  const openReferral = () => {
    props.onOpenReferral?.()
  }

  return (
    <MobileMenuPrimaryPage>
      <div>
        {user && (
          <MobileMenuLinkWrapper
            id='nav_classes_mobile'
            aria-label='My pratice'
            onClick={() => {
              window.dataLayer.push({ event: 'my_practice_click' })
              props.pageSelected('my_practice')
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <ResponsiveSVG SVG={YogaMat} width='1.7rem' height='1.5rem' />
              My Practice
            </div>
            <ChevronRightIcon color='grey' />
          </MobileMenuLinkWrapper>
        )}

        {topCategory.map((item) => (
          <MobileMenuLinkWrapper
            id={`nav_${item.value}_mobile`}
            key={item.key}
            aria-label={item.value}
            onClick={() => props.pageSelected(item.key)}
          >
            {item.value}
            <ChevronRightIcon color='grey' />
          </MobileMenuLinkWrapper>
        ))}
        <MobileMenuLinkWrapper
          id={`nav_instructors_mobile`}
          key={`nav_instructors_mobile`}
          aria-label={`Instructors`}
          onClick={() => props.pageSelected(`nav_instructors_mobile`)}
        >
          <CommonLink to={'/explore/instructors'} key={'Instructors'}>
            Instructors
          </CommonLink>
        </MobileMenuLinkWrapper>
        {!EVENTS_MENU_DISABLED && (
          <MobileMenuLinkWrapper
            id='nav_events_mobile'
            key='nav_events_mobile'
            aria-label='Events'
            onClick={() => props.pageSelected(`nav_events_mobile`)}
          >
            <CommonLink to={'/events'} key={'Instructors'}>
              Events
              {NEW_NAVBAR_ITEMS.includes('events') && (
                <sup
                  style={{
                    fontSize: '12px',
                    fontWeight: '400',
                    textTransform: 'uppercase',
                    marginLeft: '2px',
                    lineHeight: '24px'
                  }}
                >
                  NEW
                </sup>
              )}
            </CommonLink>
          </MobileMenuLinkWrapper>
        )}
      </div>

      {user && (
        <Fragment>
          <MobileMenuLink
            href={`/users/${user.username}`}
            aria-label='Profile Menu'
            id='nav_profile_mobile'
            style={{ display: 'none' }}
          >
            My Profile
          </MobileMenuLink>
          <MobileMenuLink
            href='/settings/profile'
            id='nav_settings_mobile'
            aria-label='Settings'
          >
            Settings
          </MobileMenuLink>
          <HalfDivider />
        </Fragment>
      )}
      {user && user?.aloLinkedStatus && (
        <MobileMenuLink
          href={window.REACT_ENV_VARIABLES.ALO_POINTS_PAGE_URL}
          target='_blank'
          id='nav_alo_access_mobile'
          className='unstyled'
        >
          Alo Access
        </MobileMenuLink>
      )}
      <MobileMenuLink
        href='/alo_shop_si_web'
        id='alo_shop_si_web'
        className='unstyled'
        rel='noopener noreferrer'
        target='_blank'
      >
        Shop
        <ResponsiveSVG
          marginLeft={'0.5rem'}
          SVG={AloMovesLogo}
          width='1.7rem'
          height='1.5rem'
        />
      </MobileMenuLink>

      <HalfDivider />

      {user && (
        <Fragment>
          <MobileMenuLink
            as='div'
            role='button'
            tabIndex={0}
            id='nav_refer_friend_mobile'
            className='unstyled'
            style={{ cursor: 'pointer' }}
            onClick={openReferral}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault()
                openReferral()
              }
            }}
          >
            Refer a Friend
          </MobileMenuLink>
          <MobileMenuLink
            as={CommonLink}
            to='/support'
            id='nav_gethelp_mobile'
            className='unstyled'
          >
            Get Help
          </MobileMenuLink>
          <MobileMenuLink
            href='/signout'
            id='nav_logout_mobile'
            className='unstyled'
          >
            Sign Out
          </MobileMenuLink>
        </Fragment>
      )}

      {!user && (
        <Fragment>
          <MobileMenuLink as={CommonLink} to='/signin' id='nav_signin_mobile'>
            Sign In
          </MobileMenuLink>
        </Fragment>
      )}

      <HalfDivider />
      <AppStoreComponent style={{ padding: '0 15px' }} />
    </MobileMenuPrimaryPage>
  )
}

export default MobileMenuPrimary
